/* ENTITLED — Shopify storefront interactions */

const $ = (sel, root = document) => root.querySelector(sel);
const $$ = (sel, root = document) => [...root.querySelectorAll(sel)];

const ROUTES = (window.Shopify && window.Shopify.routes) || { root: '/' };
const CART_URL = (window.theme && window.theme.cartUrl) || '/cart';
const SEARCH_URL = (window.theme && window.theme.searchUrl) || '/search';

// ============ MONEY FORMATTING ============
function formatMoney(cents) {
  // Shopify cart AJAX returns prices in cents
  const dollars = Math.round(cents) / 100;
  if (dollars % 1 === 0) {
    return '$' + dollars.toLocaleString('en-US', { maximumFractionDigits: 0 });
  }
  return '$' + dollars.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

// ============ INTRO CURTAIN (home only) ============
const intro = document.getElementById('intro');
if (intro && !sessionStorage.getItem('entitled_intro_seen')) {
  document.body.style.overflow = 'hidden';
  requestAnimationFrame(() => {
    intro.classList.add('is-revealed');
  });
  setTimeout(() => {
    intro.classList.add('is-done');
    document.body.style.overflow = '';
    sessionStorage.setItem('entitled_intro_seen', '1');
    document.querySelector('.hero')?.classList.add('is-in');
    animateHeroTitle();
  }, 1700);
} else if (intro) {
  intro.remove();
  document.querySelector('.hero')?.classList.add('is-in');
  setTimeout(animateHeroTitle, 80);
} else {
  document.querySelector('.hero')?.classList.add('is-in');
  setTimeout(animateHeroTitle, 80);
}

// ============ HERO KINETIC TYPE ============
function animateHeroTitle() {
  document.querySelectorAll('.hero__title-line').forEach((line, lineIdx) => {
    const text = line.dataset.line || line.textContent.trim();
    line.innerHTML = '';
    [...text].forEach((ch, i) => {
      const span = document.createElement('span');
      span.className = 'char';
      span.textContent = ch === ' ' ? '\u00A0' : ch;
      span.style.transitionDelay = `${(lineIdx * 0.15) + (i * 0.04)}s`;
      line.appendChild(span);
    });
    requestAnimationFrame(() => line.classList.add('is-in'));
  });
}

// ============ SPLIT TEXT ============
function splitHeadline(el) {
  if (el.dataset.split === 'done') return;
  const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
  const textNodes = [];
  let node;
  while ((node = walker.nextNode())) {
    if (node.nodeValue.trim()) textNodes.push(node);
  }
  textNodes.forEach((textNode) => {
    const frag = document.createDocumentFragment();
    const words = textNode.nodeValue.split(/(\s+)/);
    words.forEach((word) => {
      if (/^\s+$/.test(word)) {
        frag.appendChild(document.createTextNode(word));
        return;
      }
      const wordWrap = document.createElement('span');
      wordWrap.className = 'word';
      [...word].forEach((ch) => {
        const charSpan = document.createElement('span');
        charSpan.className = 'char';
        charSpan.textContent = ch;
        wordWrap.appendChild(charSpan);
      });
      frag.appendChild(wordWrap);
    });
    textNode.parentNode.replaceChild(frag, textNode);
  });
  el.querySelectorAll('.char').forEach((c, i) => {
    c.style.transitionDelay = `${i * 0.018}s`;
  });
  el.dataset.split = 'done';
}
document.querySelectorAll('.split').forEach(splitHeadline);

// ============ NAV SCROLL STATE + OVER-DARK DETECTION ============
const nav = document.getElementById('nav');
if (nav) {
  const darkSelectors = ['.hero', '.strip', '.feature', '.stockists', '.page-hero',
    '.manifesto-hero', '.atelier-hero', '.lookbook-hero', '.atelier-numbers',
    '.cta-band', '.article__hero', '.plates'];
  const darkEls = darkSelectors.flatMap(s => $$(s));

  function updateNav() {
    const scrolled = window.scrollY > 24;
    nav.classList.toggle('is-scrolled', scrolled);
    const navBottom = 73;
    const overDark = darkEls.some(el => {
      const r = el.getBoundingClientRect();
      return r.top <= navBottom && r.bottom > navBottom;
    });
    nav.classList.toggle('is-over-dark', overDark);
  }
  updateNav();
  window.addEventListener('scroll', updateNav, { passive: true });
  window.addEventListener('resize', updateNav);
}

// ============ CART (Shopify AJAX API) ============
const cartEl = document.getElementById('cart');
const cartBtn = document.getElementById('cartBtn');
const cartCount = document.getElementById('cartCount');
const cartBody = document.getElementById('cartBody');
const cartFooter = document.getElementById('cartFooter');
const cartTotal = document.getElementById('cartTotal');
const cartCheckout = document.getElementById('cartCheckout');

function fetchCart() {
  return fetch('/cart.js', { credentials: 'same-origin' }).then(r => r.json());
}

function renderCart(data) {
  if (cartCount) cartCount.textContent = data.item_count || 0;
  if (!cartBody) return;
  if (!data.items || data.items.length === 0) {
    cartBody.innerHTML = '<p class="cart__empty">Your bag is empty.<br/><em>Rien de moins.</em></p>';
    if (cartFooter) cartFooter.hidden = true;
    return;
  }
  cartBody.innerHTML = data.items.map(item => {
    const meta = [item.options_with_values && item.options_with_values.map(o => o.value).join(' · ')]
      .filter(Boolean).join(' · ');
    const img = item.image ? `<img src="${item.image}" alt="" />` : '';
    return `
      <div class="cart__item" data-key="${item.key}">
        <div class="cart__item-img">${img}</div>
        <div>
          <div class="cart__item-name">${item.product_title}</div>
          <div class="cart__item-meta">${meta ? meta + ' · ' : ''}Qty ${item.quantity}</div>
          <button class="cart__item-remove" data-remove="${item.key}" type="button">Remove</button>
        </div>
        <div class="cart__item-price">${formatMoney(item.final_line_price)}</div>
      </div>
    `;
  }).join('');
  if (cartFooter) cartFooter.hidden = false;
  if (cartTotal) cartTotal.textContent = formatMoney(data.total_price);
}

function refreshCart() {
  return fetchCart().then(renderCart);
}

function openCart() {
  cartEl?.classList.add('is-open');
  cartEl?.setAttribute('aria-hidden', 'false');
}
function closeCart() {
  cartEl?.classList.remove('is-open');
  cartEl?.setAttribute('aria-hidden', 'true');
}

cartBtn?.addEventListener('click', (e) => {
  e.preventDefault();
  refreshCart().then(openCart);
});
cartEl?.addEventListener('click', (e) => { if (e.target.matches('[data-close]')) closeCart(); });

document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') {
    closeCart();
    closeMobileDrawer();
    closeSearch();
  }
});

cartBody?.addEventListener('click', (e) => {
  const key = e.target.dataset.remove;
  if (!key) return;
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    body: JSON.stringify({ id: key, quantity: 0 })
  })
    .then(r => r.json())
    .then(renderCart);
});

cartCheckout?.addEventListener('click', () => {
  window.location.href = '/checkout';
});

// initial cart fetch — keeps count fresh
refreshCart();

// ============ NEWSLETTER ============
const nlForm = document.getElementById('nlForm');
const nlSuccess = document.getElementById('nlSuccess');
nlForm?.addEventListener('submit', (e) => {
  // Shopify form submits to /contact, but for visual we keep success state
  // Don't preventDefault — let Shopify handle the submit
  setTimeout(() => {
    nlForm.style.display = 'none';
    nlSuccess?.classList.add('is-shown');
  }, 50);
});

// ============ REVEAL ON SCROLL ============
const io = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('is-visible');
      io.unobserve(entry.target);
    }
  });
}, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });

document.querySelectorAll('.card, .atelier__card, .manifesto__inner, .feature__content, .strip__cell, .jcard, .plate, .cross__card, .process__step, .atelier-number, .atelier-imagery__cell').forEach(el => {
  el.classList.add('reveal');
  io.observe(el);
});
document.querySelectorAll('.split').forEach(el => io.observe(el));

// ============ MAGNETIC BUTTONS ============
const isFinePointer = window.matchMedia('(pointer: fine)').matches;
if (isFinePointer) {
  document.querySelectorAll('.btn--magnetic').forEach((btn) => {
    const strength = 0.25;
    btn.addEventListener('mousemove', (e) => {
      const rect = btn.getBoundingClientRect();
      const cx = rect.left + rect.width / 2;
      const cy = rect.top + rect.height / 2;
      const dx = (e.clientX - cx) * strength;
      const dy = (e.clientY - cy) * strength;
      btn.style.transform = `translate(${dx}px, ${dy}px)`;
    });
    btn.addEventListener('mouseleave', () => {
      btn.style.transform = '';
    });
  });
}

// ============ PARALLAX on editorial strip ============
if (isFinePointer && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
  const stripImgs = document.querySelectorAll('.strip__cell img');
  if (stripImgs.length) {
    let ticking = false;
    function applyParallax() {
      stripImgs.forEach((img, i) => {
        const cell = img.closest('.strip__cell');
        const rect = cell.getBoundingClientRect();
        const winH = window.innerHeight;
        const progress = (rect.top + rect.height / 2 - winH / 2) / winH;
        const offset = progress * 22 * (i % 2 === 0 ? -1 : 1);
        img.style.transform = `translateY(${offset.toFixed(1)}px) scale(1.06)`;
      });
      ticking = false;
    }
    window.addEventListener('scroll', () => {
      if (!ticking) {
        requestAnimationFrame(applyParallax);
        ticking = true;
      }
    }, { passive: true });
    applyParallax();
  }
}

// ============ MOBILE DRAWER ============
const mobileDrawer = document.getElementById('mobileDrawer');
const navToggle = document.getElementById('navToggle');
function openMobileDrawer() {
  mobileDrawer?.classList.add('is-open');
  mobileDrawer?.setAttribute('aria-hidden', 'false');
}
function closeMobileDrawer() {
  mobileDrawer?.classList.remove('is-open');
  mobileDrawer?.setAttribute('aria-hidden', 'true');
}
navToggle?.addEventListener('click', openMobileDrawer);
mobileDrawer?.addEventListener('click', (e) => {
  if (e.target.matches('[data-mobile-close]')) closeMobileDrawer();
});
$$('.mobile-drawer__nav a').forEach(a => a.addEventListener('click', closeMobileDrawer));

// ============ SEARCH OVERLAY (Shopify predictive search) ============
const searchEl = document.getElementById('search');
const searchBtn = document.getElementById('searchBtn');
const searchInput = document.getElementById('searchInput');
const searchResults = document.getElementById('searchResults');
const searchForm = document.getElementById('searchForm');

function openSearch() {
  searchEl?.classList.add('is-open');
  searchEl?.setAttribute('aria-hidden', 'false');
  setTimeout(() => searchInput?.focus(), 60);
}
function closeSearch() {
  searchEl?.classList.remove('is-open');
  searchEl?.setAttribute('aria-hidden', 'true');
}
searchBtn?.addEventListener('click', openSearch);
searchEl?.addEventListener('click', (e) => {
  if (e.target.matches('[data-search-close]')) closeSearch();
});
// Allow form to submit to /search for full results
// searchForm submits via GET as configured

let searchTimer = null;
function runPredictiveSearch(q) {
  if (!searchResults) return;
  const query = q.trim();
  if (!query) { searchResults.innerHTML = ''; return; }
  const url = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,article,page&resources[limit]=8`;
  fetch(url, { headers: { 'Accept': 'application/json' } })
    .then(r => r.json())
    .then(data => {
      const r = (data && data.resources && data.resources.results) || {};
      const items = [];
      (r.products || []).forEach(p => {
        items.push({
          type: 'Product',
          title: p.title,
          meta: p.product_type || (p.vendor || ''),
          url: p.url,
          image: p.featured_image && (p.featured_image.url || p.featured_image)
        });
      });
      (r.articles || []).forEach(a => {
        items.push({
          type: 'Journal',
          title: a.title,
          meta: 'Field Notes',
          url: a.url,
          image: a.image && (a.image.url || a.image)
        });
      });
      (r.pages || []).forEach(p => {
        items.push({
          type: 'Page',
          title: p.title,
          meta: 'House',
          url: p.url,
          image: ''
        });
      });
      if (items.length === 0) {
        searchResults.innerHTML = '<p class="sr-empty">Nothing found. <em>Rien.</em></p>';
        return;
      }
      searchResults.innerHTML = items.slice(0, 8).map(m => `
        <a href="${m.url}">
          <div class="sr-thumb">${m.image ? `<img src="${m.image}" alt="" />` : ''}</div>
          <div class="sr-info">
            <div class="sr-title">${m.title}</div>
            <div class="sr-meta">${m.type} · ${m.meta || ''}</div>
          </div>
        </a>
      `).join('');
    })
    .catch(() => {
      searchResults.innerHTML = '<p class="sr-empty">Nothing found. <em>Rien.</em></p>';
    });
}

searchInput?.addEventListener('input', (e) => {
  clearTimeout(searchTimer);
  const v = e.target.value;
  searchTimer = setTimeout(() => runPredictiveSearch(v), 180);
});

// ============ PDP — color/size picker + Shopify add ============
const pdpRoot = document.querySelector('.pdp');
if (pdpRoot) {
  const product = window.ENTITLED_PRODUCT || null;
  const productForm = document.getElementById('product-form');
  const variantInput = pdpRoot.querySelector('[data-pdp-variant-id]');
  const addBtn = $('[data-pdp-add]', pdpRoot);

  // Track selections per option index (1-based in Shopify, 0-based here)
  const selectedOptions = {};

  // Default-select the first color and (if only one) size
  const firstColorBtn = $('.pdp__color', pdpRoot);
  if (firstColorBtn) {
    firstColorBtn.classList.add('is-selected');
    selectedOptions[firstColorBtn.dataset.optionIndex] = firstColorBtn.dataset.color;
    // Set swatch CSS var for visual based on data
    syncColorSwatch(firstColorBtn);
  }
  const sizeBtns = $$('.pdp__size', pdpRoot);
  if (sizeBtns.length === 1) {
    sizeBtns[0].classList.add('is-selected');
    selectedOptions[sizeBtns[0].dataset.optionIndex] = sizeBtns[0].dataset.size;
  }

  function syncColorSwatch(btn) {
    // Try to find a media variant with matching option, swap gallery hero
    if (!product) return;
    const colorName = btn.dataset.color;
    const variant = (product.variants || []).find(v => (v.options || []).includes(colorName));
    // gallery switching handled by data-shot-color filter in main-product.liquid
    // Color dot styling — derive a hex from a known palette or fallback
    const palette = { 'Bone': '#EFE8DA', 'Onyx': '#0E0E0E', 'Ivory': '#EFE8DA', 'Black': '#0E0E0E', 'White': '#FFFFFF' };
    const hex = palette[colorName] || '#888';
    btn.style.setProperty('--swatch', hex);
  }

  // Pre-stamp swatches on all color buttons
  $$('.pdp__color', pdpRoot).forEach(syncColorSwatch);

  $$('.pdp__color', pdpRoot).forEach(btn => {
    btn.addEventListener('click', () => {
      $$('.pdp__color', pdpRoot).forEach(b => b.classList.remove('is-selected'));
      btn.classList.add('is-selected');
      selectedOptions[btn.dataset.optionIndex] = btn.dataset.color;
      syncColorSwatch(btn);
      updateAddState();
    });
  });

  $$('.pdp__size', pdpRoot).forEach(btn => {
    btn.addEventListener('click', () => {
      $$('.pdp__size', pdpRoot).forEach(b => b.classList.remove('is-selected'));
      btn.classList.add('is-selected');
      selectedOptions[btn.dataset.optionIndex] = btn.dataset.size;
      updateAddState();
    });
  });

  function getMatchingVariant() {
    if (!product || !product.variants) return null;
    // Build options array in order
    const optionCount = (product.options || []).length;
    const opts = [];
    for (let i = 0; i < optionCount; i++) {
      opts.push(selectedOptions[i] || null);
    }
    if (opts.some(o => o === null)) {
      // Allow auto for option not represented in UI (e.g. Title with single value)
      for (let i = 0; i < optionCount; i++) {
        if (opts[i] === null) {
          // If only one possible value across variants, fill it
          const distinct = [...new Set(product.variants.map(v => v.options[i]))];
          if (distinct.length === 1) opts[i] = distinct[0];
        }
      }
    }
    if (opts.some(o => o === null)) return null;
    return product.variants.find(v => v.options.every((val, idx) => val === opts[idx])) || null;
  }

  function updateAddState() {
    if (!addBtn) return;
    const variant = getMatchingVariant();
    if (variant) {
      if (variantInput) variantInput.value = variant.id;
      const price = formatMoney(variant.price);
      if (variant.available) {
        addBtn.classList.remove('is-disabled');
        addBtn.disabled = false;
        addBtn.textContent = `Add to Bag — ${price}`;
      } else {
        addBtn.classList.add('is-disabled');
        addBtn.disabled = true;
        addBtn.textContent = 'Sold Out';
      }
    } else {
      const need = [];
      if ($$('.pdp__color', pdpRoot).length && !Object.values(selectedOptions).some(v => isColorValue(v))) need.push('color');
      if ($$('.pdp__size', pdpRoot).length && !Object.values(selectedOptions).some(v => !isColorValue(v))) need.push('size');
      const labelNeed = need.length ? `Select ${need.join(' & ')}` : 'Select options';
      addBtn.textContent = labelNeed;
      addBtn.classList.add('is-disabled');
      addBtn.disabled = true;
    }
  }

  function isColorValue(val) {
    if (!val) return false;
    return $$('.pdp__color', pdpRoot).some(b => b.dataset.color === val);
  }

  updateAddState();

  // Intercept form submit — add via AJAX, then open cart drawer
  productForm?.addEventListener('submit', (e) => {
    e.preventDefault();
    const variant = getMatchingVariant();
    if (!variant) {
      addBtn.textContent = 'Select size & color';
      setTimeout(updateAddState, 1200);
      return;
    }
    const formData = new FormData(productForm);
    formData.set('id', variant.id);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
      .then(r => r.json())
      .then((data) => {
        if (data.status && data.status >= 400) {
          addBtn.textContent = data.description || 'Could not add';
          setTimeout(updateAddState, 1500);
          return;
        }
        addBtn.classList.add('is-added');
        addBtn.textContent = 'Added to Bag';
        return refreshCart().then(openCart).then(() => {
          setTimeout(() => {
            addBtn.classList.remove('is-added');
            updateAddState();
          }, 1100);
        });
      })
      .catch(() => {
        addBtn.textContent = 'Could not add';
        setTimeout(updateAddState, 1500);
      });
  });
}

// ============ CONTACT FORM (visual progressive enhancement) ============
const contactForm = document.getElementById('contactForm');
const contactSuccess = document.getElementById('contactSuccess');
// Server-side success state already handled via Liquid form.posted_successfully?
